import { render } from "./ShowcasePlatform.vue?vue&type=template&id=61baed36&scoped=true"
import script from "./ShowcasePlatform.vue?vue&type=script&lang=js"
export * from "./ShowcasePlatform.vue?vue&type=script&lang=js"

import "./ShowcasePlatform.vue?vue&type=style&index=0&id=61baed36&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61baed36"]])

export default __exports__